module.exports = __webpack_public_path__ + "static/img/mybaojiapng.9e967c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mybaojiapng.png
// module id = MglC
// module chunks = 1